var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "parent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.714,
    cy: 12,
    rx: 12.714,
    ry: 12,
    fill: "#F7F8F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.643 17H11.5307V11.2168L11.5512 10.2666L11.5854 9.22754C11.2345 9.57845 10.9906 9.80859 10.8539 9.91797L9.70548 10.8408L8.68692 9.56934L11.9067 7.00586H13.643V17Z",
    fill: "parent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneIcon);
export default __webpack_public_path__ + "static/media/OneIcon.ded1eb0bc7fce72503407322d60af2b5.svg";
export { ForwardRef as ReactComponent };